import styled from "styled-components"
import noiseImage from './noise.svg'

export default styled.div`
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    filter: contrast(170%) brightness(90%);
    z-index: 4;
    pointer-events: none;
    background-image:
        linear-gradient(-1.25deg, #9e7b234d, #bf9e4580, #f6cb5980 31.5%, #f3c23f00 31.7%),
        radial-gradient(farthest-corner at 8px 40px, #c7812154, #a5550a00),
        radial-gradient(farthest-corner at -16px 30px, #ffad3d87, #a5550a00),
        radial-gradient(farthest-corner at 48px 30px, #ffad3d, #a5550a00),
        linear-gradient(70deg, #b16c0f50, #924c0c9e 76%),
        url(${noiseImage});
    mask-image: linear-gradient(-1.25deg, #000, #000, #000 31.5%, #00000000 32.5%);
    //clip-path: polygon(0 69.2%,100% 67.9%,100% 100%,0% 100%);



    @media screen and (max-height: 1100px)  {
        background-image:
        linear-gradient(-1.25deg, #9e7b234d, #bf9e4580, #f6cb5980 21.5%, #f3c23f00 21.7%),
        radial-gradient(farthest-corner at 8px 40px, #c7812154, #a5550a00),
        radial-gradient(farthest-corner at -16px 30px, #ffad3d87, #a5550a00),
        radial-gradient(farthest-corner at 48px 30px, #ffad3d, #a5550a00),
        linear-gradient(70deg, #b16c0f50, #924c0c9e 76%),
        url(${noiseImage});
        mask-image: linear-gradient(-1.25deg, #000, #000, #000 21.5%, #00000000 22.5%);
    }
    @media screen and (max-width: 1260px)  {
        background-image:
        linear-gradient(-1.25deg, #9e7b234d, #bf9e4580, #f6cb5980 21.5%, #f3c23f00 21.7%),
        radial-gradient(farthest-corner at 8px 40px, #c7812154, #a5550a00),
        radial-gradient(farthest-corner at -16px 30px, #ffad3d87, #a5550a00),
        radial-gradient(farthest-corner at 48px 30px, #ffad3d, #a5550a00),
        linear-gradient(70deg, #b16c0f50, #924c0c9e 76%),
        url(${noiseImage});
        mask-image: linear-gradient(-1.25deg, #000, #000, #000 21.5%, #00000000 22.5%);
    }
`